import { completelyFetchResource } from '../helpers/resources';
import { ApiTimeInterval } from '../types/TimeInterval';

export const getTimeIntervals = async (customerId: string) => {
  const fetchRes = await completelyFetchResource<ApiTimeInterval>(
    `timeintervals`,
    '&includeShared=true',
    { pageSize: 200 },
    customerId,
  );
  return fetchRes;
};
